import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-26433be6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "col-xl-4 col-lg-4 col-md-6 order-xl-2 mb-2 mb-xl-0"
};
var _hoisted_2 = {
  "class": "card card-profile shadow overflow-hidden"
};
var _hoisted_3 = {
  "class": "image-fix-height"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "row"
};
var _hoisted_6 = {
  "class": "col"
};
var _hoisted_7 = {
  "class": "card-profile-stats d-flex"
};
var _hoisted_8 = {
  "class": ""
};
var _hoisted_9 = {
  "class": ""
};
var _hoisted_10 = {
  "class": "row"
};
var _hoisted_11 = {
  "class": "col"
};
var _hoisted_12 = {
  "class": "card-profile-stats d-flex"
};
var _hoisted_13 = {
  "class": "text-gray"
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode(" in ");

var _hoisted_15 = {
  "class": "row"
};
var _hoisted_16 = {
  "class": "col"
};
var _hoisted_17 = {
  "class": "card-profile-stats d-flex"
};
var _hoisted_18 = {
  "class": "w-100 text-left"
};
var _hoisted_19 = {
  "class": "row text-gray"
};
var _hoisted_20 = {
  "class": "col-4 text-left"
};
var _hoisted_21 = {
  "class": "col-8 text-right"
};

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("hr", {
    "class": "my-2"
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_el_link = _resolveComponent("el-link");

  var _component_PostFootFunction = _resolveComponent("PostFootFunction");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    to: $options.postLink
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("img", {
        src: $options.imgFromStr($props.blogs.json_metadata, $props.blogs.body),
        "class": "image w-100 h-100 object-fit-cover"
      }, null, 8, _hoisted_4)];
    }),
    _: 1
  }, 8, ["to"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_router_link, {
    to: $options.postLink
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("span", _hoisted_9, _toDisplayString($props.blogs.title), 1)];
    }),
    _: 1
  }, 8, ["to"])])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_link, {
    underline: false,
    type: "primary",
    href: "/trending/" + $props.blogs.community,
    target: "_blank"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString($props.blogs.community_title), 1)];
    }),
    _: 1
  }, 8, ["href"])])])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString($options.dateDiff($props.blogs.created.replace("T", " "))), 1), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_link, {
    underline: false,
    type: "primary",
    href: "/@" + $props.blogs.author,
    target: "_blank"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("@" + _toDisplayString($props.blogs.author), 1)];
    }),
    _: 1
  }, 8, ["href"])])]), _hoisted_22, _createVNode(_component_PostFootFunction, {
    blogs: $props.blogs,
    isShowComment: true
  }, null, 8, ["blogs"])])])])])])]);
}